<template>
  <div class="GradeDesc">
    <TopCard
      :grade="getBehaviorScore"
      @libnkToGradeDetailed="libnkToGradeDetailed"
    />
    <!-- 头部部分 end -->
    <div class="bigBox">
      <div class="conBox">
        <div class="tabBox">
          <RecordDecode />
        </div>
      </div>
    </div>
    <div class="emptyBox"></div>
  </div>
</template>

<script>
import RecordDecode from "./components/RecordDecode";
import TopCard from './components/TopCard'
import { mapGetters } from "vuex";
export default {
  name: "GradeDesc",
  components: {
    TopCard,
    RecordDecode
  },
  computed: {
    ...mapGetters(["getBehaviorScore"]),
  },
  methods: {
    libnkToGradeDetailed() {
      this.$router.push({
        name: "gradeDetailed",
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.GradeDesc {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  padding-bottom: 15px;
  background-color: #f2f2f2;
  .bigBox {
    width: 100%;
    background-color: #f2f2f2;
  }
  .conBox {
    width: 90%;
    margin: 0 auto;
    flex: 1;
    // height: 100%;
    min-height: (100px - 400px);
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    .tabBox {
      width: 100%;
      height: 100%;
      background-color: #fff;
      padding: 20px 15px 0;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 14px;
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      overflow: hidden;
      .title {
        color: #abacac;
        line-height: 22px;
        margin-bottom: 20px;
      }
      .van-cell {
        border-top: 1px solid #fbfbfb;
        padding: 10px 0;
      }
    }
  }
  .emptyBox {
    width: 100%;
    height: 15px;
    background-color: #f2f2f2;
  }
}
</style>
